
import { css } from 'styled-components';
import { Colors, pxToRem } from '@maskott/tactileo.designsystem';

export const styles = {
  text:  css`
    h1 {
        color: ${(p) =>
              Colors('157, 88%', p.theme.colors.lightness.light30, 1)};
    }

    h2 {
        color: ${(p) =>
              Colors('275, 41%', p.theme.colors.lightness.light40, 1)};
    }

    h3 {
        color: ${(p) =>
              Colors('0, 0%', 0, 1)};
    }

    p {
        color: ${(p) =>
              Colors('0, 1%', p.theme.colors.lightness.light30, 1)};
    }
  `,

  button:  css`
    button[design="primary"] {
        border-color:  ${(p) =>
              Colors(p.theme.colors.secondary, 43, 1)};
    }
    button[design="primary"]:hover:enabled {
        background-color:  ${(p) =>
              Colors(p.theme.colors.secondary, 90, 1)};
    } 
  `,

  box : css`
    border-color: ${(p) => Colors(p.theme.colors.secondary, 43, 1)};
  `,

  choice : css `
    border-color: ${(p) => Colors(p.theme.colors.primary, 30, 1)};
  `,

  avatarMessage: css`
    border-color: ${(p) => Colors(p.theme.colors.secondary, 43, 1)};
  `,

  sticker: css `
    border-color: ${(p) => Colors(p.theme.colors.secondary, 43, 1)};
  `,

  logo:  css`
     height: ${pxToRem(60)};
  `,
};